// @ts-nocheck

import React, {createContext, useContext, useEffect, useImperativeHandle, useRef, useState} from "react";
import {LoadingOutlined} from '@ant-design/icons';
import styled, {keyframes, useTheme} from 'styled-components';
import {hexToRgbA} from "../../services/app";
import {getThemeIsDefault, getThemeLogo} from "../../services/color";
import {useApp} from "../../contexts/app";

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const antIcon = <LoadingOutlined style={{fontSize: 32}} spin/>;

const Container = styled.div`
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.45);
    flex: 1;
    width: 100%;
    height: 100%;
`;

const ContainerSpin = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    //height: 70px;
    //width: 70px;
    //background-color: #fff;
    //border-radius: 4px;
`;

export default function Loading(props) {
    return (
        <Container>
            <ContainerSpin>
                <NewLoading/>
            </ContainerSpin>
        </Container>
    )
}


const loadingHtml = (theme: any = {}) => {
    return `
<div style="position: relative;
  width: 100px;
  height: 100px;
  z-index: 9999;
  background-color: #FFFFFF;">
  ${!getThemeIsDefault() ?
        "<img alt=' ' style='position: absolute; width: 100%; height: 100%; top: 0; left: 0; padding: 24px;border-radius: 100%;' src='" + getThemeLogo() + "'/>"
        : '<svg style="border-radius: 100%;position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    transition: none;" width="238" height="238" viewBox="0 0 238 238" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6419_162932)">\n<path d="M144.782 81.3563C144.6 81.2473 144.418 81.1563 144.235 81.0654C144.053 80.9745 143.88 80.8927 143.697 80.8109C131.726 75.5563 113.838 82.5654 99.4332 90.6563C90.9542 95.4291 83.6786 100.565 79.5394 103.793L79.5212 103.811C78.3998 104.684 77.1507 105.775 75.9108 106.993C75.7831 107.111 75.6555 107.238 75.5461 107.365C75.309 107.611 75.0628 107.865 74.8167 108.12C74.3335 108.629 73.8594 109.165 73.4126 109.711C72.9659 110.256 72.5374 110.802 72.1271 111.356C72.0268 111.502 71.9265 111.638 71.8353 111.784C71.5527 112.202 71.2883 112.629 71.033 113.047C70.4586 114.029 70.0028 115.02 69.7293 115.975C68.9452 118.693 68.5987 121.756 69.6381 124.82C69.7019 125.011 69.7749 125.211 69.8478 125.402C70.0393 125.884 70.2672 126.365 70.5316 126.847C70.9601 127.611 71.4798 128.375 72.1271 129.111C72.6924 129.765 73.3397 130.411 74.0873 131.038C74.6161 131.493 75.2087 131.929 75.8469 132.365C76.7404 132.975 77.7433 133.575 78.8647 134.147C79.0288 134.229 79.193 134.311 79.3571 134.402C79.8494 134.647 80.36 134.893 80.8979 135.12C81.0802 135.202 81.2626 135.275 81.4449 135.356C81.9919 135.593 82.5663 135.82 83.1681 136.038C83.3686 136.111 83.5783 136.193 83.7789 136.265C84.1892 136.411 84.5995 136.556 85.0371 136.702C86.1221 137.065 87.2708 137.411 88.4834 137.747C89.386 137.993 90.2977 138.22 91.2095 138.429C91.72 138.547 92.2306 138.656 92.7412 138.765C98.9409 140.047 105.259 140.538 110.921 140.62C110.921 140.638 110.921 140.656 110.921 140.675C111.814 150.902 117.166 160.747 117.166 160.747C118.233 162.847 119.929 164.275 121.998 165.093C124.925 166.275 128.608 166.247 132.283 165.238C140.47 163.002 146.661 156.293 148.584 148.056C148.922 146.593 149.323 144.838 149.742 142.829C150.891 137.356 152.222 130.111 153.07 122.484C154.957 105.629 154.529 86.9018 144.746 81.3473L144.782 81.3563ZM133.358 124.756C133.304 124.775 133.258 124.784 133.203 124.793C127.678 126.002 113.209 126.911 103.654 125.92C103.372 125.893 103.089 125.865 102.816 125.829C102.396 125.784 101.986 125.72 101.594 125.665C101.485 125.647 101.384 125.638 101.284 125.62C101.02 125.575 100.764 125.538 100.509 125.493C100.5 125.493 100.491 125.493 100.473 125.493C99.9803 125.411 99.5244 125.311 99.0776 125.211C97.2633 124.784 96.0507 124.102 95.2849 123.302C92.7594 120.729 94.674 117.002 94.674 117.002C94.674 117.002 94.674 117.002 94.6831 116.993C96.7163 113.802 100.053 110.656 103.782 107.856C103.809 107.838 103.837 107.811 103.873 107.793C103.955 107.738 104.074 107.638 104.247 107.511C104.402 107.393 104.557 107.284 104.712 107.175C104.913 107.029 105.113 106.884 105.323 106.738C105.487 106.62 105.642 106.511 105.806 106.402C105.888 106.338 105.989 106.284 106.071 106.211C106.235 106.093 106.399 105.984 106.572 105.875C106.691 105.793 106.8 105.72 106.928 105.638C112.644 101.838 118.707 98.9654 122.29 97.9927C122.29 97.9927 122.293 97.9927 122.299 97.9927C122.509 97.9382 122.719 97.8836 122.91 97.8382C124.196 97.5473 125.372 97.3836 126.438 97.3654C126.676 97.3745 126.922 97.3745 127.159 97.3745H127.195C127.533 97.3927 127.852 97.4291 128.171 97.4745C128.28 97.4836 128.39 97.5109 128.499 97.5382C128.617 97.5654 128.736 97.5927 128.864 97.62C129.511 97.7745 130.104 98.02 130.651 98.3473C131.252 98.7109 131.799 99.1745 132.283 99.7563C134.197 102.056 135.136 106.147 135.136 112.556C135.136 116.02 134.27 120.293 133.377 124.775L133.358 124.756Z" fill="#1EC28B"/>\n<path d="M133.212 124.801C128.052 126.046 113.382 126.964 103.663 125.928C103.38 125.901 103.098 125.873 102.824 125.837C102.405 125.791 101.995 125.728 101.602 125.673C101.493 125.655 101.393 125.646 101.292 125.628C101.028 125.582 100.773 125.546 100.518 125.501C100.508 125.501 100.499 125.501 100.481 125.501C99.9887 125.41 99.5329 125.319 99.0861 125.21C97.2718 124.782 96.0683 124.101 95.2933 123.31C92.7679 120.737 94.6825 117.01 94.6825 117.01C94.6825 117.01 94.6825 117.01 94.6916 117.001C100.29 108.228 115.607 99.8187 122.289 98.0005C122.289 98.0005 122.293 98.0005 122.299 98.0005C122.299 98.0005 122.308 98.0005 122.317 98.0005C136.403 91.1187 80.6693 103.573 79.557 103.819C79.5479 103.819 79.5388 103.819 79.5388 103.819C78.4173 104.701 77.1592 105.791 75.9283 107.01C75.8007 107.128 75.673 107.255 75.5636 107.382C75.3266 107.628 75.0804 107.882 74.8343 108.137C74.351 108.646 73.877 109.182 73.4302 109.728C72.9743 110.273 72.5458 110.819 72.1447 111.373C72.0444 111.519 71.9441 111.655 71.8529 111.801C71.5612 112.219 71.2968 112.646 71.0506 113.064C70.4762 114.046 70.0204 115.037 69.7468 115.991C68.9628 118.71 68.6163 121.773 69.6557 124.837C69.7195 125.028 69.7924 125.228 69.8654 125.419C70.0568 125.901 70.2848 126.382 70.5492 126.864C70.9777 127.628 71.5065 128.382 72.1447 129.128C72.7099 129.773 73.3664 130.419 74.1049 131.055C74.6428 131.501 75.2263 131.946 75.8645 132.382C76.758 132.991 77.7609 133.582 78.8823 134.164C79.0464 134.246 79.2105 134.328 79.3746 134.419C79.867 134.664 80.3867 134.901 80.9155 135.137C81.0978 135.219 81.2801 135.291 81.4625 135.373C82.0095 135.601 82.5839 135.837 83.1856 136.055C83.3862 136.128 83.5959 136.21 83.7965 136.282C84.2068 136.428 84.6171 136.573 85.0547 136.719C86.1396 137.082 87.2793 137.428 88.501 137.764C89.4036 138.01 90.3153 138.237 91.227 138.446C91.7376 138.564 92.2482 138.673 92.7587 138.782C99.0223 140.101 105.35 140.601 110.939 140.691H111.03C120.904 140.855 128.544 139.746 129.693 139.573C129.693 139.573 131.516 134.046 133.34 124.773C133.294 124.773 133.239 124.791 133.185 124.801H133.212Z" fill="url(#paint0_linear_6419_162932)"/>\n<path d="M129.703 139.562C129.01 141.581 122.974 158.281 113.137 162.644C111.067 161.817 113.118 161.49 112.052 159.39C112.052 159.39 111.879 150.899 110.967 140.69H111.049C120.905 140.844 128.517 139.753 129.703 139.562V139.562Z" fill="url(#paint1_radial_6419_162932)"/>\n<path d="M130.642 98.346C130.068 97.9642 129.457 97.746 128.855 97.6187C128.727 97.5914 128.609 97.5642 128.49 97.5369C128.381 97.5096 128.271 97.4823 128.162 97.4733C127.825 97.4096 127.506 97.3733 127.186 97.3733H127.15C126.913 97.3733 126.667 97.3733 126.43 97.3642C120.312 97.246 111.55 102.519 106.919 105.637C106.8 105.719 106.682 105.791 106.563 105.873C106.399 105.991 106.235 106.101 106.062 106.21C105.971 106.273 105.879 106.337 105.797 106.401C105.633 106.51 105.478 106.619 105.314 106.737C105.086 106.901 104.886 107.046 104.703 107.173C104.521 107.301 104.366 107.419 104.238 107.51C104.065 107.637 103.938 107.737 103.865 107.791C103.81 107.837 103.773 107.855 103.773 107.855L99.4336 90.6642C113.848 82.5733 131.736 75.5642 143.698 80.8187C143.88 80.9005 144.053 80.9823 144.236 81.0733C144.418 81.1642 144.6 81.2551 144.783 81.3642C154.575 86.9187 154.994 105.646 153.107 122.501C152.259 130.128 150.928 137.373 149.779 142.846C149.779 142.846 155.459 114.882 130.642 98.3551V98.346Z" fill="url(#paint2_linear_6419_162932)"/>\n</g>\n<defs>\n<linearGradient id="paint0_linear_6419_162932" x1="113.911" y1="150.355" x2="95.7384" y2="107.09" gradientUnits="userSpaceOnUse">\n<stop stop-color="#007044"/>\n<stop offset="1" stop-color="#007044" stop-opacity="0"/>\n</linearGradient>\n<radialGradient id="paint1_radial_6419_162932" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(134.015 136.69) scale(24.3521 24.2818)">\n<stop stop-color="#004027"/>\n<stop offset="1" stop-color="#004027" stop-opacity="0"/>\n</radialGradient>\n<linearGradient id="paint2_linear_6419_162932" x1="156.626" y1="106.319" x2="115.323" y2="117.406" gradientUnits="userSpaceOnUse">\n<stop stop-color="#24D394"/>\n<stop offset="1" stop-color="#00FFA4" stop-opacity="0"/>\n</linearGradient>\n<linearGradient id="paint3_linear_6419_162932" x1="240.733" y1="31.0352" x2="340.841" y2="138.556" gradientUnits="userSpaceOnUse">\n<stop stop-color="#39A086"/>\n<stop offset="1" stop-color="#80DDC8"/>\n</linearGradient>\n<linearGradient id="paint4_linear_6419_162932" x1="152.334" y1="-5.22373e-06" x2="284.074" y2="141.495" gradientUnits="userSpaceOnUse">\n<stop stop-color="#39A086"/>\n<stop offset="1" stop-color="#80DDC8"/>\n</linearGradient>\n<clipPath id="clip0_6419_162932">\n<rect width="85" height="87" fill="white" transform="translate(69 79)"/>\n</clipPath>\n</defs>\n</svg>\n'}
<svg style="
            position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transition: none;
    animation: spin infinite 3s normal;
    animation-delay: 0.5s;
    top: 18px;
    left: 18px;
    width: calc(100% - 36px);
    height: calc(100% - 36px);
    " width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.4" x="161.566" y="6.50781" width="155.056" height="155.056" rx="42" transform="rotate(90 161.566 6.50781)" stroke="url(#paint0_linear_6479_163158)" stroke-width="12"/>
<defs>
<linearGradient id="paint0_linear_6479_163158" x1="227.094" y1="12.5078" x2="327.202" y2="120.029" gradientUnits="userSpaceOnUse">
<stop stop-color="${theme.main || "#39A086"}"/>
<stop offset="1" stop-color="${hexToRgbA(theme.main, 0.9) || "#80DDC8"}"/>
</linearGradient>
</defs>
</svg>
<svg
 
 style="
            position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transition: none;
    
    top: 12px;
    left: 12px;
    width: calc(100% - 24px);
    height: calc(100% - 24px);
    animation: spin infinite 3s normal;
    animation-direction: reverse;
    "
 width="193" height="193" viewBox="0 0 193 193" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.4" x="1" y="1" width="190.259" height="190.259" rx="49" stroke="url(#paint0_linear_6479_163159)" stroke-width="2"/>
<defs>
<linearGradient id="paint0_linear_6479_163159" x1="96.1293" y1="1.99999" x2="227.869" y2="143.495" gradientUnits="userSpaceOnUse">
<stop stop-color="${theme.main || "#39A086"}"/>
<stop offset="1" stop-color="${hexToRgbA(theme.main, 0.9) || "#80DDC8"}"/>
</linearGradient>
</defs>
</svg>
</div>
`;
}

export const LoadingInline = React.forwardRef((props, ref) => {
    const top = props.top || 1;
    const radius = props.radius || 1;
    const [loading, setLoading] = useState(true);
    const currentRef = useRef();
    const currentDiv = useRef();
    const theme = useTheme();

    useImperativeHandle(ref, () => ({
        hide: () => {
            onHide()
        },
        show: () => {
            onShow()
        }
    }));


    useEffect(() => {
        onShow();
    }, []);

    const onShow = () => {
        const elm = getElement();
        elm.querySelectorAll('.loading-item-inline').forEach(item => item.remove())
        const div = document.createElement('div');
        div.classList.add('loading-item-inline')
        currentDiv.current = div;
        div.setAttribute('style', `
              transition: all 0.3s;
              position: absolute;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 2;
              background-color: white;
              opacity: 1;
              top: 0;
              left: 0;
              border-radius: ${radius}px
        `)
        div.innerHTML = loadingHtml(theme || {});
        elm.style.position = 'relative';
        elm.style.overflow = 'hidden';
        elm.style.transition = 'all 0.1s';
        elm.appendChild(div);
        elm.style.opacity = 1;
    }

    const onHide = () => {
        currentDiv.current.style.opacity = 0;
        setTimeout(() => {
            currentDiv.current.remove();
            const elm = getElement();
            elm.querySelectorAll('.loading-item-inline').forEach(item => item.remove())
        }, 400);
    }

    const getElement = () => {
        let current = currentRef.current;
        for (let i = 0; i < top; i++) {
            current = current.parentElement;
        }
        return current;
    }

    return (<div ref={currentRef}/>)
})


const LoadingContext = createContext({});

const LoadingInlineContainer = styled.div`
    position: relative;
`;
const LoadingInlineView = styled.div`
    transition: all 0.3s ease-out;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 2;
    background-color: white;
    opacity: 1;
    top: 0;
    left: 0;
    padding-top: 150px;

    &.hide {
        opacity: 0;
    }

    &.master {
        position: fixed;
        align-items: center;
        padding-top: 0px;
    }
`;
export const InlineLoadingContainer = React.forwardRef((props, ref) => {
    const [loading, setLoading] = useState(true);
    const [loadingVisible, setLoadingVisible] = useState(true);
    const isMaster = props.master;

    useImperativeHandle(ref, () => ({
        hide: () => {
            setLoading(false)
        },
        show: () => {
            setLoading(true)
        }
    }));


    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                setLoadingVisible(false);
            }, 400);
        } else {
            setLoadingVisible(true)
        }
    }, [loading]);

    return (
        <LoadingContext.Provider value={{loading, setLoading}}>
            <LoadingInlineContainer style={{
                minHeight: (props.height | (window.innerHeight - 100)), ...(loading ? ({
                    height: isMaster ? "300px" : "auto",
                    borderRadius: 12,
                    overflow: "hidden"
                }) : ({}))
            }}>
                <div {...props}>
                    {props.children}
                </div>
                {loadingVisible ? (
                    <LoadingInlineView className={`${isMaster ? "master" : ""} ${!loading ? "hide" : ""}`}>
                        {/*<Spin size={'small'} indicator={antIcon}/>*/}
                        <NewLoading/>
                    </LoadingInlineView>) : null}
            </LoadingInlineContainer>
        </LoadingContext.Provider>
    )
})

export const useInlineLoading = () => useContext(LoadingContext);

const NewLoadingDiv = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0);

    svg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transition: none;
    }

    img {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        padding: 24px;
        border-radius: 100%;
    }

    svg:nth-child(1) {
        border-radius: 100%;
    }

    svg:nth-child(2) {
        animation: ${spin} infinite 3s normal;
        animation-delay: 0.5s;
        top: 18px;
        left: 18px;
        width: calc(100% - 36px);
        height: calc(100% - 36px);
    }

    svg:nth-child(3) {
        top: 12px;
        left: 12px;
        width: calc(100% - 24px);
        height: calc(100% - 24px);
        animation: ${spin} infinite 3s normal;
        animation-direction: reverse;
    }

`;
export const NewLoading = (props) => {
    const {themeColors} = useApp();
    const theme = useTheme() || themeColors || {};


    return (
        <NewLoadingDiv>
            {
                !getThemeIsDefault() ? (<img src={getThemeLogo()}/>) : (
                    <svg width="238" height="238" viewBox="0 0 238 238" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_6419_162932)">
                            <path
                                d="M140.989 86.2018C140.828 86.1052 140.667 86.0248 140.506 85.9443C140.345 85.8639 140.192 85.7914 140.031 85.719C129.469 81.0685 113.685 87.2719 100.975 94.4328C93.4932 98.657 87.0736 103.203 83.4214 106.059L83.4053 106.075C82.4158 106.848 81.3137 107.813 80.2196 108.891C80.107 108.996 79.9944 109.109 79.8978 109.221C79.6887 109.439 79.4715 109.664 79.2543 109.889C78.8279 110.34 78.4096 110.814 78.0154 111.297C77.6212 111.78 77.2431 112.263 76.8811 112.754C76.7926 112.882 76.7041 113.003 76.6237 113.132C76.3743 113.502 76.141 113.88 75.9157 114.25C75.4089 115.119 75.0067 115.996 74.7654 116.841C74.0735 119.247 73.7678 121.958 74.6849 124.67C74.7412 124.839 74.8056 125.016 74.8699 125.185C75.0389 125.611 75.24 126.037 75.4733 126.464C75.8514 127.14 76.3099 127.816 76.8811 128.467C77.3799 129.047 77.951 129.618 78.6107 130.173C79.0773 130.575 79.6002 130.962 80.1633 131.348C80.9517 131.887 81.8366 132.418 82.8261 132.925C82.9709 132.997 83.1157 133.07 83.2605 133.15C83.6949 133.367 84.1454 133.585 84.62 133.786C84.7809 133.858 84.9418 133.922 85.1027 133.995C85.5854 134.204 86.0922 134.405 86.6231 134.598C86.8001 134.663 86.9851 134.735 87.1621 134.799C87.5241 134.928 87.8861 135.057 88.2723 135.186C89.2296 135.508 90.2432 135.813 91.3132 136.111C92.1096 136.328 92.914 136.529 93.7185 136.714C94.169 136.819 94.6195 136.916 95.07 137.012C100.54 138.147 106.115 138.581 111.111 138.654C111.111 138.67 111.111 138.686 111.111 138.702C111.899 147.754 116.622 156.467 116.622 156.467C117.563 158.326 119.059 159.589 120.885 160.313C123.468 161.359 126.718 161.335 129.96 160.442C137.184 158.463 142.646 152.525 144.343 145.235C144.641 143.94 144.995 142.387 145.365 140.609C146.379 135.765 147.553 129.352 148.301 122.602C149.966 107.685 149.588 91.1098 140.957 86.1937L140.989 86.2018ZM130.909 124.613C130.861 124.629 130.82 124.637 130.772 124.645C125.897 125.716 113.13 126.52 104.699 125.643C104.45 125.619 104.201 125.595 103.959 125.563C103.589 125.522 103.227 125.466 102.881 125.418C102.785 125.402 102.696 125.394 102.608 125.378C102.375 125.337 102.149 125.305 101.924 125.265C101.916 125.265 101.908 125.265 101.892 125.265C101.457 125.193 101.055 125.104 100.661 125.016C99.0601 124.637 97.9902 124.034 97.3144 123.326C95.0861 121.049 96.7754 117.75 96.7754 117.75C96.7754 117.75 96.7754 117.75 96.7835 117.742C98.5774 114.918 101.522 112.134 104.812 109.656C104.836 109.64 104.86 109.616 104.892 109.599C104.965 109.551 105.069 109.463 105.222 109.35C105.359 109.245 105.496 109.149 105.633 109.052C105.81 108.924 105.987 108.795 106.172 108.666C106.316 108.562 106.453 108.465 106.598 108.368C106.67 108.312 106.759 108.264 106.831 108.199C106.976 108.095 107.121 107.998 107.274 107.902C107.378 107.829 107.475 107.765 107.587 107.693C112.631 104.329 117.981 101.787 121.143 100.926C121.143 100.926 121.145 100.926 121.151 100.926C121.336 100.878 121.521 100.829 121.69 100.789C122.824 100.532 123.862 100.387 124.803 100.371C125.012 100.379 125.229 100.379 125.438 100.379H125.471C125.768 100.395 126.05 100.427 126.331 100.467C126.428 100.475 126.524 100.499 126.621 100.524C126.726 100.548 126.83 100.572 126.943 100.596C127.514 100.733 128.037 100.95 128.52 101.24C129.05 101.562 129.533 101.972 129.96 102.487C131.649 104.522 132.477 108.143 132.477 113.816C132.477 116.881 131.713 120.663 130.925 124.629L130.909 124.613Z"
                                fill={"#1EC28B"}/>
                            <path
                                d="M130.78 124.654C126.226 125.756 113.283 126.569 104.707 125.652C104.458 125.627 104.208 125.603 103.967 125.571C103.597 125.531 103.235 125.475 102.889 125.426C102.792 125.41 102.704 125.402 102.615 125.386C102.382 125.346 102.157 125.314 101.932 125.273C101.924 125.273 101.915 125.273 101.899 125.273C101.465 125.193 101.063 125.113 100.669 125.016C99.0677 124.638 98.0058 124.034 97.322 123.334C95.0937 121.057 96.783 117.759 96.783 117.759C96.783 117.759 96.783 117.759 96.7911 117.75C101.73 109.986 115.245 102.544 121.142 100.934C121.142 100.934 121.145 100.934 121.15 100.934C121.15 100.934 121.158 100.934 121.166 100.934C133.595 94.8436 84.4184 105.867 83.437 106.084C83.429 106.084 83.4209 106.084 83.4209 106.084C82.4314 106.864 81.3213 107.83 80.2352 108.908C80.1226 109.013 80.01 109.125 79.9135 109.238C79.7043 109.455 79.4871 109.68 79.2699 109.906C78.8435 110.356 78.4252 110.831 78.031 111.314C77.6288 111.796 77.2507 112.279 76.8967 112.77C76.8082 112.899 76.7197 113.019 76.6393 113.148C76.3819 113.518 76.1486 113.896 75.9314 114.267C75.4246 115.136 75.0223 116.013 74.781 116.857C74.0892 119.263 73.7835 121.975 74.7005 124.686C74.7569 124.855 74.8212 125.032 74.8856 125.201C75.0545 125.627 75.2556 126.054 75.4889 126.48C75.867 127.156 76.3336 127.824 76.8967 128.484C77.3955 129.055 77.9747 129.626 78.6263 130.19C79.101 130.584 79.6158 130.978 80.1789 131.364C80.9673 131.903 81.8522 132.426 82.8417 132.941C82.9865 133.014 83.1313 133.086 83.2761 133.167C83.7105 133.384 84.1691 133.593 84.6357 133.802C84.7965 133.875 84.9574 133.939 85.1183 134.011C85.601 134.213 86.1078 134.422 86.6388 134.615C86.8157 134.679 87.0008 134.752 87.1778 134.816C87.5398 134.945 87.9018 135.073 88.2879 135.202C89.2452 135.524 90.2508 135.83 91.3288 136.127C92.1252 136.345 92.9297 136.546 93.7341 136.731C94.1846 136.836 94.6351 136.932 95.0856 137.029C100.612 138.195 106.195 138.638 111.127 138.718H111.207C119.919 138.863 126.661 137.882 127.674 137.729C127.674 137.729 129.283 132.837 130.892 124.63C130.852 124.63 130.804 124.646 130.755 124.654H130.78Z"
                                fill="url(#paint0_linear_6419_162932)"/>
                            <path
                                d="M127.682 137.719C127.071 139.505 121.745 154.285 113.065 158.147C111.239 157.415 113.049 157.126 112.108 155.267C112.108 155.267 111.955 147.752 111.15 138.716H111.223C119.919 138.853 126.636 137.888 127.682 137.719Z"
                                fill="url(#paint1_radial_6419_162932)"/>
                            <path
                                d="M128.511 101.239C128.005 100.902 127.466 100.708 126.935 100.596C126.822 100.572 126.717 100.548 126.613 100.523C126.516 100.499 126.42 100.475 126.323 100.467C126.026 100.411 125.744 100.379 125.462 100.379H125.43C125.221 100.379 125.004 100.379 124.795 100.371C119.397 100.266 111.666 104.933 107.579 107.692C107.475 107.765 107.37 107.829 107.266 107.902C107.121 108.006 106.976 108.103 106.823 108.199C106.743 108.256 106.662 108.312 106.59 108.368C106.445 108.465 106.308 108.561 106.163 108.666C105.962 108.811 105.785 108.939 105.624 109.052C105.464 109.165 105.327 109.269 105.214 109.35C105.061 109.462 104.949 109.551 104.884 109.599C104.836 109.639 104.804 109.656 104.804 109.656L100.975 94.4406C113.693 87.2797 129.477 81.0763 140.031 85.7268C140.192 85.7993 140.345 85.8717 140.506 85.9521C140.667 86.0326 140.828 86.1131 140.989 86.2096C149.628 91.1257 149.999 107.7 148.333 122.618C147.585 129.368 146.411 135.781 145.397 140.625C145.397 140.625 150.409 115.875 128.511 101.248V101.239Z"
                                fill="url(#paint2_linear_6419_162932)"/>
                        </g>
                        <defs>
                            <linearGradient id="paint0_linear_6419_162932" x1="113.749" y1="147.271" x2="97.6311"
                                            y2="109.014"
                                            gradientUnits="userSpaceOnUse">
                                <stop stopColor="#007044"/>
                                <stop offset="1" stopColor="#007044" stopOpacity="0"/>
                            </linearGradient>
                            <radialGradient id="paint1_radial_6419_162932" cx="0" cy="0" r="1"
                                            gradientUnits="userSpaceOnUse"
                                            gradientTransform="translate(131.487 135.176) scale(21.4872 21.4908)">
                                <stop stopColor="#004027"/>
                                <stop offset="1" stopColor="#004027" stopOpacity="0"/>
                            </radialGradient>
                            <linearGradient id="paint2_linear_6419_162932" x1="151.439" y1="108.296" x2="114.979"
                                            y2="118.053"
                                            gradientUnits="userSpaceOnUse">
                                <stop stopColor="#24D394"/>
                                <stop offset="1" stopColor="#00FFA4" stopOpacity="0"/>
                            </linearGradient>
                            <linearGradient id="paint3_linear_6419_162932" x1="240.733" y1="31.0352" x2="340.841"
                                            y2="138.556"
                                            gradientUnits="userSpaceOnUse">
                                <stop stopColor="#39A086"/>
                                <stop offset="1" stopColor="#80DDC8"/>
                            </linearGradient>
                            <linearGradient id="paint4_linear_6419_162932" x1="152.334" y1="-5.22373e-06" x2="284.074"
                                            y2="141.495" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#39A086"/>
                                <stop offset="1" stopColor="#80DDC8"/>
                            </linearGradient>
                            <clipPath id="clip0_6419_162932">
                                <rect width="75" height="77" fill="white" transform="translate(74.1211 84.1172)"/>
                            </clipPath>
                        </defs>
                    </svg>
                )
            }

            <svg width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.4" x="161.566" y="6.50781" width="155.056" height="155.056" rx="42"
                      transform="rotate(90 161.566 6.50781)" stroke="url(#paint0_linear_6479_163158)"
                      strokeWidth="12"/>
                <defs>
                    <linearGradient id="paint0_linear_6479_163158" x1="227.094" y1="12.5078" x2="327.202" y2="120.029"
                                    gradientUnits="userSpaceOnUse">
                        <stop stopColor={theme.main || "#39A086"}/>
                        <stop offset="1" stopColor={hexToRgbA(theme.main, 0.9) || "#80DDC8"}/>
                    </linearGradient>
                </defs>
            </svg>

            <svg width="193" height="193" viewBox="0 0 193 193" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.4" x="1" y="1" width="190.259" height="190.259" rx="49"
                      stroke="url(#paint0_linear_6479_163159)" strokeWidth="2"/>
                <defs>
                    <linearGradient id="paint0_linear_6479_163159" x1="96.1293" y1="1.99999" x2="227.869" y2="143.495"
                                    gradientUnits="userSpaceOnUse">
                        <stop stopColor={theme.main || "#39A086"}/>
                        <stop offset="1" stopColor={hexToRgbA(theme.main, 0.9) || "#80DDC8"}/>
                    </linearGradient>
                </defs>
            </svg>

        </NewLoadingDiv>
    )
}